var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ShiciGameLayout",
    [
      _c(
        "el-card",
        {
          staticClass: "fetch-card",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "card-header" }, [
                    _c("span", [_vm._v("诗词抓取")]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-position": _vm.isMobile ? "top" : "right",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "批量抓取" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 1,
                      max: 50,
                      step: 1,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.count,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "count", $$v)
                      },
                      expression: "form.count",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.fetching,
                        disabled: _vm.fetching || _vm.fetchingByTitle,
                      },
                      on: { click: _vm.fetchShici },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.fetching ? "抓取中..." : "开始抓取") +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.fetching || _vm.fetchingByTitle },
                      on: { click: _vm.resetForm },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-tip" }, [
                    _vm._v("每次最多抓取50首诗词"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "按链接抓取" } },
                [
                  _c("el-input", {
                    staticStyle: { "max-width": "520px" },
                    attrs: {
                      size: "mini",
                      clearable: "",
                      placeholder:
                        "输入古诗文网链接，例如：https://www.gushiwen.cn/shiwenv_xxx.aspx",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.fetchShiciByURL.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.fetchURL,
                      callback: function ($$v) {
                        _vm.fetchURL = $$v
                      },
                      expression: "fetchURL",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        loading: _vm.fetchingByTitle,
                        disabled: _vm.fetching || _vm.fetchingByTitle,
                      },
                      on: { click: _vm.fetchShiciByURL },
                    },
                    [_vm._v("\n          抓取\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _vm.result
            ? _c(
                "div",
                { staticClass: "result-section" },
                [
                  _c("h3", [_vm._v("抓取结果")]),
                  _vm._v(" "),
                  _c("el-alert", {
                    attrs: {
                      type: _vm.result.success ? "success" : "error",
                      title: _vm.result.message,
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "result-stats" },
                    [
                      _c("el-statistic", {
                        attrs: { title: "新增诗词", value: _vm.result.added },
                      }),
                      _vm._v(" "),
                      _c("el-statistic", {
                        attrs: { title: "跳过重复", value: _vm.result.skipped },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.result.success && _vm.result.added > 0
                    ? _c(
                        "div",
                        { staticClass: "result-actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.goToGame },
                            },
                            [_vm._v("开始游戏")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fetching
            ? _c(
                "div",
                { staticClass: "loading-section" },
                [
                  _c("el-progress", {
                    attrs: {
                      percentage: _vm.progress,
                      status: _vm.progressStatus,
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "loading-text" }, [
                    _vm._v(_vm._s(_vm.loadingText)),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.fetchedPoems.length > 0
        ? _c(
            "el-card",
            {
              staticClass: "poems-card",
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "card-header" }, [
                          _c("span", [_vm._v("最近抓取的诗词")]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                980717151
              ),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "poems-list" },
                _vm._l(_vm.fetchedPoems, function (poem, index) {
                  return _c("div", { key: index, staticClass: "poem-item" }, [
                    _c("div", { staticClass: "poem-title" }, [
                      _vm._v(_vm._s(poem.title)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "poem-author" }, [
                      _vm._v(_vm._s(poem.author)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "poem-content" }, [
                      _vm._v(_vm._s(poem.content)),
                    ]),
                  ])
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticClass: "library-card",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "card-header" }, [
                    _c("span", [
                      _vm._v("全部诗词（" + _vm._s(_vm.listTotal) + "）"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "library-actions" },
                      [
                        _c("el-switch", {
                          attrs: { "active-text": "只看收藏" },
                          model: {
                            value: _vm.listFilters.favoriteOnly,
                            callback: function ($$v) {
                              _vm.$set(_vm.listFilters, "favoriteOnly", $$v)
                            },
                            expression: "listFilters.favoriteOnly",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: { click: _vm.resetListFilters },
                          },
                          [_vm._v("重置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "warning" },
                            on: { click: _vm.detectDuplicates },
                          },
                          [_vm._v("检测重复标题")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              loading: _vm.listing,
                            },
                            on: { click: _vm.searchList },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "library-filters" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 6 } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          clearable: "",
                          placeholder: "标题",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchList.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.listFilters.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.listFilters, "title", $$v)
                          },
                          expression: "listFilters.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 6 } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          clearable: "",
                          placeholder: "朝代",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchList.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.listFilters.dynasty,
                          callback: function ($$v) {
                            _vm.$set(_vm.listFilters, "dynasty", $$v)
                          },
                          expression: "listFilters.dynasty",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 6 } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          clearable: "",
                          placeholder: "作者",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchList.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.listFilters.author,
                          callback: function ($$v) {
                            _vm.$set(_vm.listFilters, "author", $$v)
                          },
                          expression: "listFilters.author",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 6 } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          clearable: "",
                          placeholder: "内容",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchList.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.listFilters.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.listFilters, "content", $$v)
                          },
                          expression: "listFilters.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.listError
            ? _c("el-alert", {
                staticClass: "list-error",
                attrs: {
                  type: "error",
                  title: _vm.listError,
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listing,
                  expression: "listing",
                },
              ],
              staticClass: "plain-table-wrap",
            },
            [
              _c("table", { staticClass: "plain-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticStyle: { width: "55px" } }, [_vm._v("#")]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "90px" } }, [
                      _vm._v("朝代"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "120px" } }, [
                      _vm._v("作者"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { "min-width": "140px" } }, [
                      _vm._v("标题"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "70px" } }, [
                      _vm._v("收藏"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "90px" } }, [
                      _vm._v("优先级"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { "min-width": "360px" } }, [
                      _vm._v("内容"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { "min-width": "260px" } }, [
                      _vm._v("注释"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "100px" } }, [
                      _vm._v("操作"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.listItems, function (row, idx) {
                    return _c("tr", { key: _vm.rowKey(row) || idx }, [
                      _c("td", { attrs: { "data-label": "#" } }, [
                        _vm._v(
                          _vm._s(
                            (_vm.listPage - 1) * _vm.listPageSize + idx + 1
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "朝代" } }, [
                        _vm._v(_vm._s(row.dynasty || "-")),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "作者" } }, [
                        _vm._v(_vm._s(row.authorName || "-")),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "标题" } }, [
                        _vm._v(_vm._s(row.title || "-")),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "收藏" } },
                        [
                          row.favorite
                            ? _c(
                                "el-tag",
                                {
                                  class: { "hover-active": true },
                                  staticStyle: {
                                    cursor: "pointer",
                                    transition: "all 0.3s",
                                  },
                                  attrs: { type: "success", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFavorite(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                已收藏\n              "
                                  ),
                                ]
                              )
                            : _c(
                                "el-tag",
                                {
                                  class: { "hover-active": true },
                                  staticStyle: {
                                    cursor: "pointer",
                                    transition: "all 0.3s",
                                  },
                                  attrs: { type: "info", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFavorite(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                未收藏\n              "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "优先级" } }, [
                        _vm._v(_vm._s(row.priority || 1)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cell-multiline",
                          attrs: { "data-label": "内容" },
                        },
                        [_vm._v(_vm._s(row.content || "-"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cell-multiline",
                          attrs: { "data-label": "注释" },
                        },
                        [_vm._v(_vm._s(row.annotation || "-"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "操作" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.editPriority(row)
                                },
                              },
                            },
                            [_vm._v("修改优先级")]
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          !_vm.listing && !_vm.listError && _vm.listItems.length === 0
            ? _c("div", { staticClass: "list-empty" }, [
                _vm._v("\n      暂无数据\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "library-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPage,
                  "page-size": _vm.listPageSize,
                  total: _vm.listTotal,
                  layout: "prev, pager, next",
                },
                on: { "current-change": _vm.onListPageChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改优先级",
            visible: _vm.priorityDialogVisible,
            width: _vm.isMobile ? "92%" : "400px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.priorityDialogVisible = $event
            },
          },
        },
        [
          _vm.currentShici
            ? _c("div", { staticClass: "priority-dialog-content" }, [
                _c("div", { staticClass: "dialog-poem-info" }, [
                  _c("h4", [_vm._v(_vm._s(_vm.currentShici.title))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.currentShici.author))]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "priority-selector" },
                  [
                    _c("label", [_vm._v("选择优先级 (1-5):")]),
                    _vm._v(" "),
                    _c("el-rate", {
                      attrs: {
                        max: 5,
                        texts: ["低", "较低", "中等", "较高", "高"],
                        "show-text": "",
                        colors: [
                          "#99A9BF",
                          "#F7BA2A",
                          "#FF9900",
                          "#FF6600",
                          "#FF3300",
                        ],
                      },
                      model: {
                        value: _vm.newPriority,
                        callback: function ($$v) {
                          _vm.newPriority = $$v
                        },
                        expression: "newPriority",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.priorityDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.updating },
                  on: { click: _vm.confirmUpdatePriority },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重复标题检测",
            visible: _vm.duplicateDialogVisible,
            width: _vm.isMobile ? "94%" : "800px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.duplicateDialogVisible = $event
            },
          },
        },
        [
          _vm.detectingDuplicates
            ? _c("div", { staticClass: "text-center padding-20" }, [
                _c("i", { staticClass: "el-icon-loading is-loading" }),
                _vm._v(" "),
                _c("span", { staticClass: "margin-left-10" }, [
                  _vm._v("正在检测重复标题..."),
                ]),
              ])
            : _vm.duplicateGroups.length === 0
            ? _c("div", { staticClass: "text-center padding-20" }, [
                _c("i", { staticClass: "el-icon-check" }),
                _vm._v(" "),
                _c("span", { staticClass: "margin-left-10" }, [
                  _vm._v("未发现重复标题"),
                ]),
              ])
            : _c(
                "div",
                _vm._l(_vm.duplicateGroups, function (group, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "duplicate-group" },
                    [
                      _c("h4", { staticClass: "duplicate-title" }, [
                        _vm._v("标题: " + _vm._s(group.title)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: group.items,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "id", label: "ID", width: "180" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "author", label: "作者" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "content",
                              label: "内容",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "createTime",
                              label: "创建时间",
                              width: "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formatTime(scope.row.createTime)
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "danger",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.confirmDelete(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      index < _vm.duplicateGroups.length - 1
                        ? _c("el-divider")
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.duplicateDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }